import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../ui/Button';
import { Field } from '../ui/Field';
import { supabase } from './supabase-client';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState<{ text: string; kind: 'status' | 'error' } | null>(null);

  async function requestReset(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!supabase) return;
    setPending(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/nouveau-mot-de-passe`,
    });
    setMessage(
      error
        ? { text: 'La demande n’a pas pu être envoyée.', kind: 'error' }
        : {
            text: 'Si ce compte existe, un lien de réinitialisation a été envoyé.',
            kind: 'status',
          },
    );
    setPending(false);
  }

  return (
    <main className="auth-page">
      <section className="auth-story" aria-label="Présentation ALBA">
        <div>
          <p className="eyebrow">ALBA</p>
          <h2>Une tâche, un tap, une décision.</h2>
        </div>
        <p className="auth-story__footer">Direction, pôles et agences, au même endroit.</p>
      </section>
      <section className="auth-card" aria-labelledby="reset-title">
        <p className="eyebrow">ALBA</p>
        <h1 id="reset-title">Mot de passe oublié</h1>
        <form onSubmit={(event) => void requestReset(event)} className="auth-form">
          <Field
            label="Adresse email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
          <Button type="submit" disabled={pending}>
            {pending ? 'Envoi en cours' : 'Envoyer le lien'}
          </Button>
        </form>
        <Link className="text-button" to="/connexion">
          Retour à la connexion
        </Link>
        {message && (
          <p
            className={message.kind === 'error' ? 'error-state' : 'status-message'}
            role={message.kind === 'error' ? 'alert' : 'status'}
          >
            {message.text}
          </p>
        )}
      </section>
    </main>
  );
}
